import { createFileRoute } from "@tanstack/react-router";
import { SmsCampaignsPage } from "@/features/sms/campaigns-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/sms/kampanie")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.sms.kampanie", location.pathname);
	},
	component: SmsCampaignsPage,
});
